
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CheckboxContainer extends Vue {
  @Prop() label!: string;
}
